import { Component } from '@angular/core';

/**
 * Component that displays a list of app tiles in a section.
 * Only to be used in mobile views
 */
@Component({
    selector: 'ohp-app-tiles-section',
    templateUrl: './app-tiles-section.component.html'
})
export class AppTilesSectionComponent {
}
